import Script from 'next/script';

export const AdsGram = () => {
  if (!process.env.ADS_GRAM_BLOCK_ID) return null;

  return <Script src="https://sad.adsgram.ai/js/sad.min.js" />;
};
